export const apiFetch = (request, opts) => {
  const appConfig = useAppConfig()

  return $fetch(request, { baseURL: appConfig.API_BASE_URL, ...opts })
}
